/** @description always include jQuery in this manner in every file where jQuery is used */
import Sliders from './sliders';
import Popup from './popup';
import LazyLoading from './lazyLoad';
import 'slick-carousel';
const $ = jQuery.noConflict();

const Gallery = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */


	/** @description Initialize */
	init: function() {
		this.sliderGallery();
		this.galleryBoxes();
		this.getCategory();
		this.loadMore();
	},

	sliderGallery: function() {
		const url = window.location.href;
		const hashes = url.split('?')[1];
		if (hashes) {
			const title = hashes.split('=')[0];
			const number = hashes.split('=')[1];

			if (window.location.href.indexOf(title) > -1) {
				// setTimeout(() => {
				// 	if (window.matchMedia('(min-width: 1200px)').matches) { // If media query matches
				// 		$('html,body').animate({
				// 			scrollTop: $('#slider-gallery').offset().top + 200
				// 		}, 500);
				// 	}
				// 	if (window.matchMedia('(max-width: 1200px)').matches) { // If media query matches
				// 		$('html,body').animate({
				// 			scrollTop: $('#slider-gallery').offset().top + 50
				// 		}, 500);
				// 	}
				// }, 2500);
				setTimeout(() => {
					$(`.js-slider-gallery__box:not('.slick-cloned')[data-cat-title="${title}"]`).trigger('click');
				}, 1500);
				// setTimeout(() => {
				// 	$('.js-gallery-detail').slick('slickGoTo', number - 1);
				// }, 5000);
			}
		}

		$('.js-slider-gallery__box').on('click', function() {
			Gallery.postId = $(this).attr('data-cat');

			$.ajax({
				type: 'POST',
				// eslint-disable-next-line no-undef
				url: LaibelAjax.ajaxUrl,
				data: {
					action: 'GetGallery',
					postId: Gallery.postId,
				},

				beforeSend: function() {
					$('.js-loader').addClass('active');
				},
				success: function(response) {
					$('.js-loader').removeClass('active');
					const galleryDetail = $(response.htmlPosts);
					galleryDetail.addClass('is-active');
					$('.js-gallery-wrap').html(galleryDetail);
					Sliders.initGalleryDetail();
					Popup.closePopupGalleryIcon();
				}
			});
		});

	},

	galleryBoxes: function() {
		$('.js-gallery-boxes__box').on('click', function() {
			Gallery.postId = $(this).attr('data-cat');
			$.ajax({
				type: 'POST',
				// eslint-disable-next-line no-undef
				url: LaibelAjax.ajaxUrl,
				data: {
					action: 'GetGallery',
					postId: Gallery.postId,
				},
				beforeSend: function() {
					$('.js-loader').addClass('active');
				},
				success: function(response) {
					$('.js-loader').removeClass('active');
					const galleryDetail = $(response.htmlPosts);
					galleryDetail.addClass('is-active');
					$('.js-gallery-wrap').html(galleryDetail);
					Sliders.initGalleryDetail();
					Popup.closePopupGalleryIcon();
				}
			});
		});
	},

	getCategory: function() {
		const count = $('.js-category-gallery').attr('data-count');
		if (count <= 4) {
			$('.js-gallery-load-more').hide();
		} else {
			$('.js-gallery-load-more').show();
		}

		const i = $('.js-category-gallery').attr('data-i');
		const catId = $('.js-category-gallery').attr('data-cat-gallery');



		$('.js-gallery-load-more').attr('data-i', i);
		$('.js-gallery-load-more').attr('data-cat', catId);


		$('.js-category-gallery').click((e) => {
			const i = $(e.currentTarget).attr('data-i');
			const catId = $(e.currentTarget).attr('data-cat-gallery');
			const count = $(e.currentTarget).attr('data-count');
			$.ajax({
				type: 'POST',
				// eslint-disable-next-line no-undef
				url: LaibelAjax.ajaxUrl,
				data: {
					action: 'LoadMorePosts',
					postId: catId,
					i: i,
					count: count,
				},
				success: function() {
					$('.js-gallery-load-more').attr('data-i', i);
					$('.js-gallery-load-more').attr('data-cat', catId);
					$('.js-delete-wrap').remove();
					if (count <= 4) {
						$('.js-gallery-load-more').hide();
					} else {
						$('.js-gallery-load-more').show();
					}
				},
			});
		});
	},

	loadMore: function() {
		$('.js-gallery-load-more').click((e) => {
			const i = $(e.currentTarget).attr('data-i');
			const catId = $(e.currentTarget).attr('data-cat');

			$.ajax({
				type: 'POST',
				// eslint-disable-next-line no-undef
				url: LaibelAjax.ajaxUrl,
				data: {
					action: 'LoadMorePosts',
					i: i,
					postId: catId,
				},
				success: function(response) {
					$(response.htmlPosts).appendTo($('.js-append'));
					$('.js-gallery-load-more').hide();
					$('.js-category-gallery').click(function(){
						$('.js-gallery-display').hide();
					});
					$('.js-gallery-display').click(() => {
						const displayCat = $('.js-gallery-display').attr('data-cat');
						$.ajax({
							type: 'POST',
							// eslint-disable-next-line no-undef
							url: LaibelAjax.ajaxUrl,
							data: {
								action: 'GetGallery',
								postId: displayCat,
							},
							success: function(response) {
								const galleryDetail = $(response.htmlPosts);
								galleryDetail.addClass('is-active');
								$('.js-gallery-wrap-display').html(galleryDetail);
								Sliders.initGalleryDetail();
								Popup.closePopupGalleryIcon();
								LazyLoading.init();
							}
						});
					});

					LazyLoading.init();
					$('.js-delete-wrap:empty').remove();
				},
				error: function(error) {
					console.log('e', error);
				}
			});
		});
	},
};

export default Gallery;
